interface ISortingOrder {
  ASC: SortOrderType;
  DESC: SortOrderType;
}

export const sortingOrder: ISortingOrder = {
  ASC: 'asc',
  DESC: 'desc',
};
